// extracted by mini-css-extract-plugin
module.exports = {"tripDecor":"Trips_tripDecor__8C4LV","tripDecorCard":"Trips_tripDecorCard__261DR","selfTripDiv":"Trips_selfTripDiv__3pjEy","selfTripCard":"Trips_selfTripCard__efQY_"};